import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'

import Flex from '../../Layout/Flex/Flex'
import Font from '../../Core/Typography/Font/Font'
import {
  ProgressBarLabel,
  CurrentStep,
  ProgressContainer,
  ProgressIndicator,
} from './ProgressBar.styles'
import { ProgressBarProps } from './types'

const ProgressBar: FC<ProgressBarProps> = props => {
  const { isWarning, isDone, stepList } = props

  // eslint-disable-next-line
  const { t } = useTranslation<any>()

  if(!Array.isArray(stepList) || (Array.isArray(stepList) && stepList?.length === 0)) return null

  // 100 percent divided per the total steps will give how much percentage each step represents, then multiplies by the number of completed steps
  const getCompletedStepsPercentage = (numberOfStepsCompleted: number) => {
    if(!numberOfStepsCompleted) return 0
    return Math.floor(100/stepListLength * numberOfStepsCompleted)
  }

  const getNumberOfCompletedSteps = () => {
    const numberOfStepsCompleted = stepList.reduce((acc, currentValue) => {
      if(currentValue) {
        acc++
      }
      return acc
    }, 0)

    return numberOfStepsCompleted
  }

  const getProgressBarLabel = (percentage: number) => {
    // @ts-ignore:next-line
    if (percentage === 0) return t('components.progressBar.labels.init')
    if (percentage > 0 && percentage < 100) {
      // @ts-ignore:next-line
      return t('components.progressBar.labels.onGoing')
    }
  }

  const stepListLength = stepList?.length

  const numberOfStepsCompleted = getNumberOfCompletedSteps()

  const completedStepsPercentage = isDone ? 100 : getCompletedStepsPercentage(numberOfStepsCompleted)
  // @ts-ignore:next-line
  const progressBarLabel = isDone ? t('components.progressBar.labels.completed') : getProgressBarLabel(completedStepsPercentage)

  const incompleteColor = isWarning ? 'warning' :'ultraViolet'

  return (
    <Flex flexDirection='column' alignItems='flex-start'>
      <ProgressBarLabel>
        <Font tag='h5'>
          <CurrentStep>{numberOfStepsCompleted || 0}</CurrentStep>
          {/* @ts-ignore:next-line */}
          <b>{` ${t('components.progressBar.labels.of')} `}{stepListLength || 0}</b>
          {` - ${progressBarLabel}`}
        </Font>
        <Font tag='h5'>{completedStepsPercentage}%</Font>
      </ProgressBarLabel>
      <ProgressContainer>
        <ProgressIndicator
          color={isDone ? 'green' : incompleteColor}
          percentValue={completedStepsPercentage}
        ></ProgressIndicator>
      </ProgressContainer>
    </Flex>
  )
}

export default ProgressBar
